import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  Button,
  Modal,
  TextInput,
  Dropdown,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  TableToolbarMenu,
  TableToolbarAction,
} from "@carbon/react";
import { Add } from "@carbon/icons-react";
import { callApi } from "../../../services/apiService";

const headers = [
  { key: "taluk", header: "Taluk Name" },
  { key: "district", header: "District" },
  { key: "state", header: "State" },
  { key: "country", header: "Country" },
  { key: "status", header: "Status" },
  { key: "createdBy", header: "Created By" },
  { key: "createdAt", header: "Created At" },
  { key: "actions", header: "Actions" },
];

export default function TalukMaster() {
  const [rows, setRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [talukName, setTalukName] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);

  const [districts, setDistricts] = useState([]);
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);

  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // Fetch Taluks
  const fetchTaluks = async () => {
    try {
      const response = await callApi("GET", "/taluk-masters/");
      const formatted = response.data.map((item) => ({
        id: item.id,
        taluk: item.name,
        district: item.district_name,
        districtId: item.district_id,
        state: item.state_name,
        stateId: item.state_id,
        country: item.country_name,
        countryId: item.country_id,
        status: item.status,
        createdBy: item.created_user,
        createdAt: item.created_at,
      }));
      setRows(formatted);
    } catch (error) {
      console.error("Failed to fetch taluks:", error.message);
    }
  };

  // Fetch supporting dropdown data
const fetchDropdowns = async () => {
  try {
    const distRes = await callApi("GET", "/districts/");

    console.log("District response:", distRes);
    console.log("District data:", distRes.data);

    const districtData = Array.isArray(distRes.data)
      ? distRes.data
      : distRes.data?.data || [];

    console.log("District array:", districtData);

const uniqueDistricts = Array.from(
  new Map(
    districtData
      .filter((d) => d.DISTRICT_ID && d.DISTRICT_NAME)
      .map((d) => [
        d.DISTRICT_ID,
        {
          id: d.DISTRICT_ID,
          name: d.DISTRICT_NAME,
          stateId: d.STATE_ID,
          countryId: d.country_id,
        },
      ])
  ).values()
);

setDistricts(uniqueDistricts);


  // States
    const stateRes = await callApi("GET", "/state-masters/");

    console.log("State response:", stateRes);

    const stateData = Array.isArray(stateRes.data)
      ? stateRes.data
      : stateRes.data?.data || [];

    console.log("State data:", stateData);

    setStates(
      stateData.map((s) => ({
        id: s.id ?? s.STATE_ID,
        name: s.state_name ?? s.STATE_NAME,
        countryId: s.country_id ?? s.COUNTRY_ID,
      }))
    );

    // Countries
    const countryRes = await callApi("GET", "/countries/");

    console.log("Country response:", countryRes);

    const countryData = Array.isArray(countryRes.data)
      ? countryRes.data
      : countryRes.data?.data || [];

    console.log("Country data:", countryData);

    setCountries(
      countryData.map((c) => ({
        id: c.id ?? c.COUNTRY_ID,
        name: c.c_name ?? c.name ?? c.COUNTRY_NAME,
        code: c.code ?? c.COUNTRY_CODE,
      }))
    );
  } catch (error) {
    console.error("Failed to fetch dropdowns:", error);
  }
};


  useEffect(() => {
    fetchTaluks();
    fetchDropdowns();
  }, []);

  // Modal open
  const openModal = (row = null) => {
    if (row) {
      // Edit mode
      setTalukName(row.taluk);
      setSelectedRow(row);

      const dist = districts.find((d) => d.id === row.districtId);
      const st = states.find((s) => s.id === row.stateId);
      const ctry = countries.find((c) => c.id === row.countryId);

      setSelectedDistrict(dist || null);
      setSelectedState(st || null);
      setSelectedCountry(ctry || null);
    } else {
      // Add mode
      setTalukName("");
      setSelectedRow(null);
      setSelectedDistrict(null);
      setSelectedState(null);
      setSelectedCountry(countries.find((c) => c.name === "India") || null); // default India
    }
    setIsModalOpen(true);
  };

  const resetModal = () => {
    setIsModalOpen(false);
    setTalukName("");
    setSelectedRow(null);
    setSelectedDistrict(null);
    setSelectedState(null);
    setSelectedCountry(null);
  };

  // Save
  const handleSave = async (e) => {
    e.preventDefault();
    if (!talukName.trim()) return;
    if (!selectedDistrict) return;

    const payload = {
      TALUK_ID: selectedRow ? selectedRow.id : 0,
      TALUK_NAME: talukName,
      DISTRICT_ID: selectedDistrict.id,
      STATUS: "Active",
      ...(selectedRow
        ? { UPDATED_BY_USER_ID: 1 }
        : { CREATED_BY_USER_ID: 1, UPDATED_BY_USER_ID: 1 }),
    };

    try {
      if (selectedRow) {
        await callApi("PUT", "/taluk-masters/", payload);
      } else {
        await callApi("POST", "/taluk-masters/", payload);
      }
      fetchTaluks();
      resetModal();
    } catch (error) {
      console.error("Failed to save taluk:", error.message);
    }
  };

  // Delete - using DELETE API
  const confirmDelete = (id) => {
    setDeleteId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      // Using DELETE API with taluk_id in URL
      await callApi("DELETE", `/taluk-masters/${deleteId}`);
      
      // Remove the deleted item from UI
      setRows((prev) => prev.filter((r) => r.id !== deleteId));
      
    } catch (error) {
      console.error("Failed to delete taluk:", error.message);
      // Optionally show error message to user
    } finally {
      setIsDeleteModalOpen(false);
      setDeleteId(null);
    }
  };

  // When district changes, update state + country automatically
  const handleDistrictChange = (selected) => {
    setSelectedDistrict(selected);

    const st = states.find((s) => s.id === selected.stateId);
    const ctry = countries.find((c) => c.id === selected.countryId);

    setSelectedState(st || null);
    setSelectedCountry(ctry || null);
  };

  return (
    <div>
      <TableContainer title="Taluk Master">
        <TableToolbar>
          <TableToolbarContent>
            <TableToolbarSearch persistent />
            <Button renderIcon={Add} onClick={() => openModal()}>
              Add Taluk
            </Button>
          </TableToolbarContent>
        </TableToolbar>

        <Table>
          <TableHead>
            <TableRow>
              {headers.map((header) => (
                <TableHeader key={header.key}>{header.header}</TableHeader>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.taluk}</TableCell>
                <TableCell>{row.district}</TableCell>
                <TableCell>{row.state}</TableCell>
                <TableCell>{row.country}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>{row.createdBy}</TableCell>
                <TableCell>{row.createdAt}</TableCell>
                <TableCell>
                  <TableToolbarMenu>
                    <TableToolbarAction onClick={() => openModal(row)}>
                      Edit
                    </TableToolbarAction>
                    <TableToolbarAction onClick={() => confirmDelete(row.id)}>
                      Delete
                    </TableToolbarAction>
                  </TableToolbarMenu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Add/Edit Modal */}
      <Modal
        open={isModalOpen}
        onRequestClose={resetModal}
        modalHeading={selectedRow ? "Edit Taluk" : "Add Taluk"}
        primaryButtonText="Save"
        secondaryButtonText="Cancel"
        onRequestSubmit={handleSave}
      >
        <TextInput
          id="taluk-name"
          labelText="Taluk Name"
          value={talukName}
          onChange={(e) => setTalukName(e.target.value)}
          required
          invalid={!talukName.trim()}
          invalidText="Taluk name is required"
        />

        <Dropdown
          id="district"
          titleText="District"
          label="Select District"
          items={districts}
          itemToString={(item) => (item ? item.name : "")}
          selectedItem={selectedDistrict}
          onChange={({ selectedItem }) => handleDistrictChange(selectedItem)}
        />

        <Dropdown
          id="state"
          titleText="State"
          label="State"
          items={selectedState ? [selectedState] : []}
          selectedItem={selectedState}
          itemToString={(item) => (item ? item.name : "")}
          disabled
        />

        <Dropdown
          id="country"
          titleText="Country"
          label="Country"
          items={selectedCountry ? [selectedCountry] : []}
          selectedItem={selectedCountry}
          itemToString={(item) => (item ? item.name : "")}
          disabled
        />
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        open={isDeleteModalOpen}
        modalHeading="Confirm Delete"
        primaryButtonText="Delete"
        secondaryButtonText="Cancel"
        danger
        onRequestClose={() => setIsDeleteModalOpen(false)}
        onRequestSubmit={handleConfirmDelete}
      >
        <p>Are you sure you want to delete this taluk?</p>
      </Modal>
    </div>
  );
}